import { render, staticRenderFns } from "./IrisViewer.vue?vue&type=template&id=08f05d9c&scoped=true&"
import script from "./IrisViewer.vue?vue&type=script&lang=ts&"
export * from "./IrisViewer.vue?vue&type=script&lang=ts&"
import style0 from "./IrisViewer.vue?vue&type=style&index=0&id=08f05d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f05d9c",
  null
  
)

export default component.exports